'use client';

import { Table as MantineTable } from '@mantine/core';

interface ITable {
  children: React.ReactNode;
  dataTestId?: string;
  additionalClassNames?: string;
}

export const Table = ({ children, additionalClassNames, dataTestId = 'youngones-table' }: ITable) => (
  <MantineTable data-testid={dataTestId} className={additionalClassNames} horizontalSpacing="xl" striped={true}>
    {children}
  </MantineTable>
);

Table.displayName = 'Table';
